import ChatService from '@/services/ChatService.js';
import AuthService from '@/services/AuthService.js';
import emojisDefault from '../../modules/pbxCloud/components/Chat/emoji-picker/emojis.js';
import { encryptStorage } from '@/utils/storage';
import router from '../../router';
import { makeid } from '@/utils/utils.js';
import { serverUrl, whatsappLogo } from '@/config.js';
import { apiClient } from '@/api/softphone_api';

const ui = {
  namespaced: true,
  state: {
    isSipmovilLoading: true,
    isJoinLoading: true,
    isFilterSipmovilLoading: false,
    isFilterAllChatsLoading:false,
    joinContactRenameDialog: false,
    currentTheme: localStorage.getItem('fxcrm-theme') || 'light',
  },
  mutations: {
    TOGGLE_DIALOG_RENAME(state, value){
      state.joinContactRenameDialog = value
    },
    TOGGLE_LOADING(state, value) {
      state.isSipmovilLoading = value;
    },
    TOGGLE_JOIN_LOADING(state, value) {
      state.isJoinLoading = value;
    },
    TOGGLE_FILTER_SIPMOVIL_LOADING(state, value) {
      state.isFilterSipmovilLoading = value;
    },
    TOGGLE_FILTER_ALL_CHATS_LOADING(state, value) {
      state.isFilterAllChatsLoading = value;
    },
    SET_THEME(state, theme) {
      state.currentTheme = theme;
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('fxcrm-theme', theme);
    },
  },
  getters: {
    currentTheme: (state) => state.currentTheme,
  },
  actions: {
    toggleLoading({ commit }, value) {
      commit('TOGGLE_LOADING', value);
    },
    toggleJoinLoading({ commit }, value) {
      commit('TOGGLE_JOIN_LOADING', value);
    },
    toggleFilterLoading({ commit }, value) {
      commit('TOGGLE_FILTER_SIPMOVIL_LOADING', value);
    },
    toggleFilterAllChatsLoading({ commit }, value) {
      commit('TOGGLE_FILTER_ALL_CHATS_LOADING', value);
    },
    async changeTheme({ commit }, theme) {
      try {
        commit('SET_THEME', theme);
        await apiClient.patch('/api/webrtc/update-theme-color/', { 
          theme_color: theme 
        });
        
      } catch (error) {
        console.error('Error guardando tema en BD:', error);
      }
    },
    async initTheme({ commit }) {
      try {
        const localStorageTheme = localStorage.getItem('fxcrm-theme');
        const themeColor = await apiClient.get('/api/webrtc/update-theme-color/');
        if (themeColor.data) {
          if (localStorageTheme && localStorageTheme !== themeColor.data.theme_color) {
            commit('SET_THEME', themeColor.data.theme_color);
          } else if (localStorageTheme && localStorageTheme === themeColor.data.theme_color) {
            commit('SET_THEME', localStorageTheme);
          } else if (!localStorageTheme) {
            commit('SET_THEME', themeColor.data.theme_color);
          }
        } else {
          if (localStorageTheme) {
            commit('SET_THEME', localStorageTheme);
          } else {
            commit('SET_THEME', 'light');
          }
        }
      } catch (error) {
        console.error('Error obteniendo tema de BD:', error);
      }
      

      
    },
  },
  modules: {
    emojis: {
      namespaced: true,
      state: {
        currentCategory: 'Peoples',
        showEmojis: false,
      },
      mutations: {
        TOGGLE_EMOJI(state) {
          state.showEmojis = !state.showEmojis;
        },
        CHANGE_CATEGORY(state, category) {
          state.currentCategory = category;
        },
      },
      getters: {
        categoryEmojis(state) {
          let filteredEmojis = [];
          filteredEmojis = emojisDefault.filter(
            (x) => x.category === state.currentCategory
          );
          return filteredEmojis;
        },
      },
    },
    attachments: {
      namespaced: true,
      state: {
        showAttachments: false,
        showFilesPreview: false,
        fileList: [],
        currentFilePreview: null,
        uploadingFiles: false,
      },
      mutations: {
        TOGGLE_ATTACHMENT(state) {
          state.showAttachments = !state.showAttachments;
        },
        SHOW_DRAG_PREV(state, status) {
          if (status === false) {
            state.fileList = [];
            state.showAttachments = false;
            state.currentFilePreview = null;
          }
          state.showFilesPreview = status;
        },
        APPEND_FILE(state, file) {
          const fileId = makeid(8);
          state.fileList.push({
            key: fileId,
            file,
          });
        },
        REMOVE_FILE(state, fileKey) {
          state.fileList = state.fileList.filter((x) => x.key !== fileKey);
        },
        SET_CURRENT_FILE_PREVIEW(state, file) {
          state.currentFilePreview = file;
        },
        RESET_ATTACHEMENTS_UI(state) {
          state.showAttachments = false;
          state.showFilesPreview = false;
          state.fileList = [];
          state.currentFilePreview = null;
          state.uploadingFiles = false;
        },
        INIT_UPLOAD(state) {
          state.uploadingFiles = true;
        },
      },
    },
    home: {
      namespaced: true,
      state: {
        refreshQR: false,
        qrPath: '',
        switchState: false,
        loadingQr: true,
        loadingMessage: 'Obteniendo código',
      },
      mutations: {
        TOGGLE_REFRESH(state, status) {
          state.refreshQR = status;
        },
        TOGGLE_SWITCH(state, status) {
          state.switchState = status;
        },
        TOGGLE_LOADING_QR(state, status) {
          state.loadingQr = status;
        },
        UPDATE_QR(state, qrPath) {
          state.qrPath = `${serverUrl}/${qrPath}`;
          state.refreshQR = false;
          state.loadingQr = false;
        },
        GO_TO_CHATS(state) {
          console.log('entro mutacion go to CHATS');
          state.refreshQR = false;
          state.qrPath = '';
          router.push({ name: 'Chats' });
        },
        UPDATE_LOADING_MESSAGE(state, message) {
          state.loadingMessage = message;
        },
      },
    },
    alert: {
      namespaced: true,
      state: {
        showAlert: false,
        alertText: '',
        alertDescription: '',
        alertType: 'success',
      },
      mutations: {
        DISPLAY_ALERT(state, { title, message, alertType }) {
          state.alertText = message;
          state.alertDescription = title;
          state.alertType = alertType;
          state.showAlert = true;
        },
        CLOSE_ALERT(state) {
          state.showAlert = false;
        },
      },
      actions: {
        displayAlert({ commit }, { description, message, alertType }) {
          commit('DISPLAY_ALERT', { title: description, message, alertType });
          setTimeout(function () {
            commit('CLOSE_ALERT');
          }, 3500);
        },
      },
    },
    modal: {
      namespaced: true,
      state: {
        showModal: false,
        showSupportModal: false,
        modalTitle: '',
        searchInputText: '',
        targetAction: '',
        countries: [],
        selectedCountry: {
          extension: '57',
          flag: 'https://test.sipmovil.com/media/country/flag/Colombia.png',
          holidays: {},
          name: 'Colombia',
          regex: /^(6\d{9}|3\d{9})$/,
        },
        groupInfo: null,
      },
      mutations: {
        TOGGLE_MODAL(state) {
          state.showModal = !state.showModal;
        },
        SET_TITLE(state, title) {
          state.modalTitle = title;
        },
        SET_INPUT_TEXT(state, text) {
          state.searchInputText = text;
        },
        SET_TARGET_ACTION(state, text) {
          state.targetAction = text;
        },
        SET_COUNTRIES(state, data) {
          state.countries = data;
        },
        SET_COUNTRY(state, country) {
          state.selectedCountry = country;
        },
        SET_GROUP_INFO(state, groupInfo) {
          state.groupInfo = groupInfo;
        },
        TOGGLE_SUPPORT_MODAL(state, value) {
          state.showSupportModal = value;
        },
        CLOSE_MODAL(state) {
          state.showModal = false;
        },
      },
      actions: {
        getCountries({ commit }) {
          const join = encryptStorage.getItem('user').join
          const token = join.tokenJoin;
          return AuthService.getCountries(token)
            .then((response) => {
              commit('SET_COUNTRIES', response.data.results);
              return 'Success';
            })
            .catch((error) => {
              console.error(error);
            });
        },
      },
    },
    labels: {
      namespaced: true,
      state: {
        labels: [],
        showLabels: false,
        showLabelFilter: false,
        ModshowLabelFilter:false,
        page: 1,
      },
      mutations: {
        TOGGLE_LABELS(state) {
          state.showLabels = !state.showLabels;
        },
        LOAD_LABELS(state, labels) {
          state.labels = labels;
        },
        TOGGLE_LABEL_FILTER(state, value) {
          console.log("entro filter")
          state.showLabelFilter = value;
        },
        TOGGLE_LABEL_FILTER_MODAL(state, value) {
          console.log("entro modal")
          state.ModshowLabelFilter = value;
        },
      },
      actions: {
        async updateLabelSender({ commit }, { chatId, labelId }) {
          const join = encryptStorage.getItem('user').join
          const token = join.tokenJoin;
          return ChatService.updateLabel(chatId, labelId, token)
            .then((response) => {
              commit('TOGGLE_LABELS');
              console.log(response);
              return 'Success';
            })
            .catch((error) => {
              console.log(error);
            });
        },
      },
    },
    disconnectLabels: {
      namespaced: true,
      state: {
        disconnectLabels: [],
        showDisconnectLabels: false,
      },
      mutations: {
        LOAD_DISCONNECT_LABELS(state, disconnectLabels) {
          state.disconnectLabels = disconnectLabels;
        },
      },
      actions: {
        async getDisconnectLabels({ commit }) {
          const join = encryptStorage.getItem('user').join
          const token = join.tokenJoin;
          return AuthService.getDisconnectLabels(token)
            .then((response) => {
              commit('LOAD_DISCONNECT_LABELS', response.data.results);
              return 'Success';
            })
            .catch((error) => {
              console.log(error);
            });
        },
      },
    },
    headerOptions: {
      namespaced: true,
      state: {
        showHeaderOptions: false,
      },
      mutations: {
        TOGGLE_HEADER_OPTIONS(state, value) {
          state.showHeaderOptions = value;
        },
      },
    },
    headerFexiaOptions: {
      namespaced: true,
      state: {
        showHeaderFexiaOptions: false,
      },
      mutations: {
        TOGGLE_HEADER_FEXIA_OPTIONS(state, value) {
          state.showHeaderFexiaOptions = value;
        },
      },
    },
    customerOptions: {
      namespaced: true,
      state: {
        showCustomerOptions: false,
        showSearchBar: false,
        renderChats: [],
      },
      mutations: {
        TOGGLE_CUSTOMER_OPTIONS(state, value) {
          state.showCustomerOptions = value;
        },
        TOGGLE_SEARCH_BAR(state, value) {
          state.showSearchBar = value;
        },
        SET_RENDER_CHATS(state, chats) {
          state.renderChats = chats;
        },
        SET_NEW_RENDER_CHAT(state, chat) {
          chat.contact_dialog = chat.name;
          chat.destination = chat.phone;
          chat.label = { color: '#ffffff' };
          chat.img_dialog = whatsappLogo;
          state.renderChats.splice(0, 0, chat);
        },
      },
      actions: {
        setNewRenderChat({ commit }, chat) {
          commit('SET_NEW_RENDER_CHAT', chat);
        },
      }
    },
    groupsOptions: {
      namespaced: true,
      state: {
        showGroupsOptions: false,
      },
      mutations: {
        TOGGLE_GROUPS_OPTIONS(state, value) {
          state.showGroupsOptions = value;
        },
      },
    },
    messagesOptions: {
      namespaced: true,
      state: {
        showMessagePreview: false,
        messageInPreview: '',
        isEditingMessage: false,
      },
      mutations: {
        IS_EDITING(state, value) {
          state.isEditingMessage = value;
        },
        ADD_MESSAGE_IN_PREVIEW(state, { value, msg }) {
          state.messageInPreview = msg;
          state.showMessagePreview = value;
        },
      },
    },
    notifications: {
      namespaced: true,
      state: {
        notificationData: [],
        readNotifications: [],
      },
      mutations: {
        LOAD_NOTIFICATION_DATA(state, value) {
          state.notificationData = value;
        },
        LOAD_READ_NOTIFICATION(state, value) {
          state.readNotifications = value;
        },
        PUSH_READ_NOTIFICATIONS(state, value) {
          state.readNotifications.push(value);
        },
        PREPEND_NOTIFICATION(state, notification) {
          const payload = {
            ...notification,
            sent_at: notification.sent_at || new Date().toISOString(),
          };
          const index = state.notificationData.findIndex(n => n.id === payload.id);
          if (index !== -1) {
            state.notificationData.splice(index, 1, { ...state.notificationData[index], ...payload });
          } else {
            state.notificationData.unshift(payload);
          }
        }
      },
      actions: {
        async getNotifications({ commit }) {
          return ChatService.getNotifications()
            .then((response) => {
              commit('LOAD_NOTIFICATION_DATA', response.data);
              return ChatService.getReadNotifications()
                .then((resp) => {
                  commit('LOAD_READ_NOTIFICATION', resp.data);
                  return 'Success';
                })
                .catch((error) => {
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);
            });
        },
        async readUserNotifications({ commit }, data) {
          return ChatService.readNotifications(data)
            .then(() => {
              commit('PUSH_READ_NOTIFICATIONS', data.call_id);
              return 'Success';
            })
            .catch((error) => {
              console.log(error);
            });
        },
        prependNotification({ commit }, notification) {
          commit('PREPEND_NOTIFICATION', notification);
        },
        async readAllNotifications({ commit, state }) {
          return ChatService.readAllNotifications()
            .then(() => {
              const allIds = state.notificationData.map(n => n.id);
              const merged = [...new Set([...state.readNotifications, ...allIds])];
              commit('LOAD_READ_NOTIFICATION', merged);
              return 'Success';
            })
            .catch((error) => {
              console.log(error);
            });
        },
      },
    },
  },
};

export default ui;
